import { motion } from "framer-motion";
import { Send, Twitter, LineChart, ArrowUpRight } from "lucide-react";
import { TG_URL, DEX_URL, X_URL } from "../config";

const cardMotion = (delay) => ({
  initial: { opacity: 0, y: 40 },
  whileInView: { opacity: 1, y: 0 },
  viewport: { once: true, margin: "-80px" },
  transition: { duration: 0.7, delay },
});

export default function CommunitySection() {
  return (
    <section id="community" data-testid="community-section" className="relative scroll-mt-28 py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute -left-40 top-1/4 h-[380px] w-[380px] rounded-full bg-[#00F5D4]/10 blur-[120px]" />
        <div className="absolute -right-40 bottom-0 h-[380px] w-[380px] rounded-full bg-[#FF2B4A]/10 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-6xl px-5">
        <motion.div {...cardMotion(0)} className="text-center">
          <p className="font-mono-x text-xs uppercase tracking-[0.35em] text-[#FF2B4A]">Community</p>
          <h2 className="mt-3 font-display text-3xl font-extrabold tracking-tight text-slate-50 sm:text-4xl lg:text-5xl">
            Join the <span className="text-[#00F5D4]">North Pole</span> Army
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base text-slate-400">
            This sleigh runs on community horsepower. Hop in, bring memes, help us deliver Solmas to every wallet on
            Solana.
          </p>
        </motion.div>

        <div className="mt-12 grid gap-6 md:grid-cols-2">
          <motion.div
            {...cardMotion(0.1)}
            data-testid="telegram-card"
            className="group relative overflow-hidden rounded-2xl border border-[#00F5D4]/20 bg-gradient-to-b from-white/[0.07] to-white/[0.02] p-8 transition-all duration-300 hover:border-[#00F5D4]/50 hover:shadow-[0_0_40px_rgba(0,245,212,0.15)]"
          >
            <div className="mb-6 inline-flex rounded-2xl bg-[#00F5D4]/10 p-4 text-[#00F5D4]">
              <Send className="h-8 w-8" />
            </div>
            <h3 className="font-display text-xl font-bold text-slate-50 sm:text-2xl">Telegram — Live Now</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
              The North Pole Army headquarters. Raids, memes, festive alpha and the loudest Christmas countdown on
              Solana.
            </p>
            <a
              data-testid="community-telegram-button"
              href={TG_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#00F5D4] to-[#00E676] px-6 py-3 font-display text-sm font-extrabold text-black shadow-[0_0_20px_rgba(0,245,212,0.35)] transition-all duration-200 hover:scale-[1.03] hover:shadow-[0_0_30px_rgba(0,245,212,0.6)] active:scale-[0.97]"
            >
              Join @MERRY_SOLMAS
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </motion.div>

          <motion.div
            {...cardMotion(0.2)}
            data-testid="x-card"
            className="group relative overflow-hidden rounded-2xl border border-[#FF2B4A]/20 bg-gradient-to-b from-white/[0.07] to-white/[0.02] p-8 transition-all duration-300 hover:border-[#FF2B4A]/50 hover:shadow-[0_0_40px_rgba(255,43,74,0.15)]"
          >
            <span className="absolute right-5 top-5 rounded-full border border-[#00E676]/40 bg-[#00E676]/10 px-3 py-1 font-mono-x text-[10px] uppercase tracking-[0.25em] text-[#00E676]">
              Live Now
            </span>
            <div className="mb-6 inline-flex rounded-2xl bg-[#FF2B4A]/10 p-4 text-[#FF2B4A]">
              <Twitter className="h-8 w-8" />
            </div>
            <h3 className="font-display text-xl font-bold text-slate-50 sm:text-2xl">X / Twitter</h3>
            <p className="mt-3 text-sm leading-relaxed text-slate-400 sm:text-base">
              Follow the official $SOLMAS account for raids, memes and every milestone on the sleigh ride to Solmas
              2026.
            </p>
            <a
              data-testid="community-x-button"
              href={X_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-6 inline-flex items-center gap-2 rounded-xl bg-gradient-to-r from-[#FF2B4A] to-[#FF5252] px-6 py-3 font-display text-sm font-extrabold text-white shadow-[0_0_20px_rgba(255,43,74,0.35)] transition-all duration-200 hover:scale-[1.03] hover:shadow-[0_0_30px_rgba(255,43,74,0.6)] active:scale-[0.97]"
            >
              Follow @MERRY_SOLMAS
              <ArrowUpRight className="h-4 w-4" />
            </a>
          </motion.div>
        </div>

        <motion.div {...cardMotion(0.3)} className="mt-6">
          <a
            data-testid="community-dexscreener-link"
            href={DEX_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="group flex items-center justify-between gap-4 rounded-2xl border border-white/10 bg-[#0F141C]/80 px-6 py-5 backdrop-blur-xl transition-all duration-300 hover:border-[#FF2B4A]/40"
          >
            <div className="flex items-center gap-4">
              <div className="rounded-xl bg-[#FF2B4A]/10 p-3 text-[#FF2B4A]">
                <LineChart className="h-5 w-5" />
              </div>
              <div>
                <p className="font-display text-sm font-bold text-slate-100 sm:text-base">$SOLMAS on Dexscreener</p>
                <p className="font-mono-x text-xs text-slate-500">bhceyicm...rwhp · Solana</p>
              </div>
            </div>
            <ArrowUpRight className="h-5 w-5 text-slate-500 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-[#FF2B4A]" />
          </a>
        </motion.div>
      </div>
    </section>
  );
}
